import * as React from "react";
import { renderLeagueName, renderStartTime } from "../RenderMethods";

export const renderCardDetails = (props: any, componentPrefix: string) =>
    <div className={`rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__details`}>
        {renderLeagueName(props.event.leagueName, componentPrefix)}
        {renderStartTime(props.event.eventTime, props.dict, componentPrefix)}
    </div>